import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ItemSymbolType } from '@editor/src/js/constants/toolbar-data';
import { OfficeNumberType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';
import {
    STYLE_PANEL_BOLD,
    STYLE_PANEL_ITALIC,
    STYLE_PANEL_UNDERLINE,
    STYLE_PANEL_DELETELINE,
    STYLE_PANEL_FONTSIZE_DECREASE,
    STYLE_PANEL_FONTSIZE_INCREASE,
    STYLE_PANEL_FONTCOLOR,
    STYLE_PANEL_HORIZONTAL_LEFT,
    STYLE_PANEL_HORIZONTAL_CENTER,
    STYLE_PANEL_HORIZONTAL_RIGHT,
    STYLE_PANEL_SYMBOL_CIRCLE,
    STYLE_PANEL_SYMBOL_1,
    TOOLBAR_V_ALIGN_TOP,
    TOOLBAR_V_ALIGN_CENTER,
    TOOLBAR_V_ALIGN_BOTTOM,
} from '../../img/pageIndex';
import { filterArrayWithIds } from './data-utils';
import {
    AlignType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

export const divide = { id: ActionType.DIVIDER };
export const colorValueData = [
    [null, '#000000'],
    [null, '#9B9B9B'],
    [null, '#FFFFFF'],
    [null, '#F8E71C'],
    [null, '#F5A624'],
    [null, '#F04E30'],
    [null, '#54B1FF'],
];
export const panelColorValueData = [
    [null, '#FFFFFF'],
    [null, '#000000'],
    [null, '#AE2E19'],
    [null, '#F4C243'],
    [null, '#FEFB54'],
    [null, '#53AD5B'],
    [null, '#53AEEA'],
    [null, '#0A205C'],
];

export const panelFillColorValueData = [
    [null, '#FFF'],
    [null, '#FFFFFF'],
    [null, '#000000'],
    [null, '#AE2E19'],
    [null, '#F4C243'],
    [null, '#FEFB54'],
    [null, '#53AD5B'],
    [null, '#53AEEA'],
];


export const fontGroup = [
    {
        id: ActionType.BOLD,
        tipMsg: i18n.t('加粗'),
        icon: STYLE_PANEL_BOLD,
    },
    {
        id: ActionType.ITALIC,
        tipMsg: i18n.t('斜体'),
        icon: STYLE_PANEL_ITALIC,
    },
    {
        id: ActionType.UNDERLINE,
        tipMsg: i18n.t('下划线'),
        icon: STYLE_PANEL_UNDERLINE,
    },
    {
        id: ActionType.DELETELINE,
        tipMsg: i18n.t('删除线'),
        icon: STYLE_PANEL_DELETELINE,
    },
    divide,
    {
        id: ActionType.FONTSIZE,
        icon: STYLE_PANEL_FONTSIZE_INCREASE,
        defaultValue: 4,
    },
    {
        id: ActionType.FONTSIZE,
        icon: STYLE_PANEL_FONTSIZE_DECREASE,
        defaultValue: -4,
    },
    divide,
    {
        id: ActionType.FORECOLOR,
        icon: STYLE_PANEL_FONTCOLOR,
        data: getFontData(colorValueData),
    },
    divide,
];

export const paragraphGroup = [
    {
        id: ActionType.HORIZONTAL_ALIGN,
        icon: STYLE_PANEL_HORIZONTAL_LEFT,
        defaultValue: 'horizontal_left',
    },
    {
        id: ActionType.HORIZONTAL_ALIGN,
        icon: STYLE_PANEL_HORIZONTAL_CENTER,
        defaultValue: 'horizontal_center',
    },
    {
        id: ActionType.HORIZONTAL_ALIGN,
        icon: STYLE_PANEL_HORIZONTAL_RIGHT,
        defaultValue: 'horizontal_right',
    },
    divide,
    {
        id: ActionType.ITEMNUMBER,
        icon: STYLE_PANEL_SYMBOL_CIRCLE,
        defaultValue: 'itemSymbol_circle',
    },
    {
        id: ActionType.DIGITNUMBER,
        icon: STYLE_PANEL_SYMBOL_1,
        defaultValue: 'itemSymbol_1',
    },
    divide,
];

export const stylePanelMenuItems = fontGroup.concat(paragraphGroup);

export const panelParagraphGroup = [
    {
        id: ActionType.HORIZONTAL_ALIGN,
        icon: STYLE_PANEL_HORIZONTAL_LEFT,
        defaultValue: AlignType.HORIZONTAL_LEFT,
    },
    {
        id: ActionType.HORIZONTAL_ALIGN,
        icon: STYLE_PANEL_HORIZONTAL_CENTER,
        defaultValue: AlignType.HORIZONTAL_CENTER,
    },
    {
        id: ActionType.HORIZONTAL_ALIGN,
        icon: STYLE_PANEL_HORIZONTAL_RIGHT,
        defaultValue: AlignType.HORIZONTAL_RIGHT,
    },
    {
        id: ActionType.VERTICAL_ALIGN,
        icon: TOOLBAR_V_ALIGN_TOP,
        defaultValue: AlignType.VERTICAL_TOP,
    },
    {
        id: ActionType.VERTICAL_ALIGN,
        icon: TOOLBAR_V_ALIGN_CENTER,
        defaultValue: AlignType.VERTICAL_CENTER,
    },
    {
        id: ActionType.VERTICAL_ALIGN,
        icon: TOOLBAR_V_ALIGN_BOTTOM,
        defaultValue: AlignType.VERTICAL_BOTTOM,
    },
    divide,
    {
        id: ActionType.ITEMNUMBER,
        icon: STYLE_PANEL_SYMBOL_CIRCLE,
        defaultValue: ItemSymbolType.ITEMSYMBOL_SMALL_CIRCLE,
    },
    {
        id: ActionType.DIGITNUMBER,
        icon: STYLE_PANEL_SYMBOL_1,
        defaultValue: OfficeNumberType.arabicPeriod,
    },
    divide,
];

export const colorGroup = [
    {
        id: ActionType.FORECOLOR,
        icon: STYLE_PANEL_FONTCOLOR,
        data: getFontData(panelColorValueData),
    },
    {
        id: ActionType.FILLCOLOR,
        icon: STYLE_PANEL_FONTCOLOR,
        data: getFontData(panelColorValueData),
    },
    {
        id: ActionType.BORDERCOLOR,
        icon: STYLE_PANEL_FONTCOLOR,
        data: getFontData(panelFillColorValueData),
    },
];

const styleEditPanelFontGroup = filterArrayWithIds(fontGroup, [ActionType.FORECOLOR]);
export const styleEditPanelMenuItems = styleEditPanelFontGroup.concat(panelParagraphGroup).concat(colorGroup);

function getFontData(data) {
    const sizeData: { icon: any; defaultValue: any; }[] = [];
    data.forEach((item) => {
        const sizeItem = {
            icon: item[0],
            defaultValue: item[1],
        };
        sizeData.push(sizeItem);
    });

    return sizeData;
}
